import { render } from "./IndexTypeMarchandise.vue?vue&type=template&id=67d6adcf"
import script from "./IndexTypeMarchandise.vue?vue&type=script&lang=js"
export * from "./IndexTypeMarchandise.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__